module.exports = __webpack_public_path__ + "img/zhuangyuan.e632f085.png";